import { HiCheck } from "react-icons/hi2";

export const CheckIcon = ({ width, height, color, ...props }) => (
  <HiCheck
    size={width || height || 20}
    color={color || "currentColor"}
    {...props}
  />
);
